import { render, staticRenderFns } from "./InputPPNS.vue?vue&type=template&id=209a6142&scoped=true&"
import script from "./InputPPNS.vue?vue&type=script&lang=js&"
export * from "./InputPPNS.vue?vue&type=script&lang=js&"
import style0 from "./InputPPNS.vue?vue&type=style&index=0&id=209a6142&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a6142",
  null
  
)

export default component.exports